import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=ab915236&scoped=true&"
import script from "./tips.vue?vue&type=script&lang=js&"
export * from "./tips.vue?vue&type=script&lang=js&"
import style0 from "./tips.vue?vue&type=style&index=0&id=ab915236&prod&scoped=true&lang=css&"
import style1 from "./tips.vue?vue&type=style&index=1&id=ab915236&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab915236",
  null
  
)

export default component.exports